import * as React from 'react';
import { Icon } from '@app/Components/Icon';
import { IconName } from '@fortawesome/fontawesome-svg-core';

interface IScreenDisabledProps {
    hidden: boolean;
    message: string;
    iconName?: IconName;
}

export class ScreenDisabled extends React.Component<IScreenDisabledProps> {
    render() {
        return (
            <div hidden={this.props.hidden} className="screen-disabled">
                {this.renderIcon()}
                <div className="screen-disabled-message">{this.props.message}</div>
            </div>
        );
    }

    renderIcon() {
        return this.props.iconName && <Icon name={this.props.iconName} className="screen-disabled-icon" />;
    }
}
